import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { catchError, forkJoin, map, of } from 'rxjs';
import { MainComponent } from './components/main/main.component';
import { WebviewService } from './services/platform/webview.service';
import { WaypointService } from './services/core/waypoint.service';
import { initResolver } from './resolvers/init.resolver';
import { googleSearchResolver } from './resolvers/google-search.resolver';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { InitErrorComponent } from './components/init-error/init-error.component';
import { MapReadyService } from './services/map/map-ready.service';
import { AccountService } from './services/account/account.service';

const accountResolver: ResolveFn<null> = () => {
  const accountService = inject(AccountService);
  const authorized = accountService.initAccount();
  if (!authorized) return of(null);
  return forkJoin([
    accountService.loadUserProfile(),
    accountService.getUserSettings(),
  ]).pipe(
    map(() => null),
    catchError(() => of(null)),
  );
};

const mainResolver = {
  webviewService: () => inject(WebviewService).resolve(),
  waypointService: () => { inject(WaypointService).restore(); return true; },
  initResolver: initResolver,
  accountResolverService: accountResolver,
  googleSearchResolver: googleSearchResolver,
  mapReadyService: () => { inject(MapReadyService).resolve(); return true; },
};

export const routes: Routes = [
  { path: '', component: MainComponent, resolve: mainResolver },
  { path: 'privacy-policy', component: MainComponent, resolve: mainResolver },
  { path: 'demo', component: MainComponent, resolve: mainResolver },
  { path: 'polyline', component: MainComponent, resolve: mainResolver },
  { path: 'verify-email', component: MainComponent, resolve: mainResolver },
  { path: 'terahive', component: MainComponent, resolve: mainResolver },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'delete-confirmation', component: DeleteAccountComponent },
  { path: 'init-error', component: InitErrorComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
